import {receive, iceCandidate, unMuteVideo, muteVideo} from './conference-websocket.js'

class Participant {
  name = null
  videoId = null
  audioId = null
  muted = false
  speaking = false
  muteVideo = false
  deptName = null
  deptI18n=false
  deptId = null
  roomName = null
  isVcs = false
  isTemp = false
  isGrade = false
  isShare = false
  isShowShare = true
  number = null
  //1分机 2通讯录 3号码 4摄像头 5 GB28181 6调度员 7 screen
  type = null
  status = ''
  gradeNumber = ''
  gradeName = ''
  net=''
  icon=''
  meetingIcon=''
  order = 1
  isRtsp = false
  realName = null
  playing = false
  _screenStream = null
  _screenTrack = null
  _buildingPeer = false
  _disposed = false


  constructor(name,roomName,number,type,isVcs,gradeNumber) {
    this.name = name
    this.realName = name
    this.roomName = roomName
    this.number = number
    this.type = type ? Number(type) : null
    this.isVcs = isVcs
    this.videoId = `video-${name}`
    this.audioId = `audio-${name}`
    this.muted = false
    this.speaking = false
    this.muteVideo = false
    this.gradeNumber = gradeNumber
    if (this.gradeNumber) {
      this.isGrade = true
    }
    Object.defineProperty(this,'rtcPeer',{writable:true,configurable:true})
    Object.defineProperty(this,'speakHark',{writable:true,configurable:true})

  }

  setStatus(status) {
    this.status = status
    if (this.status !== 'Talking') {
      this.meetingIcon = ''
    }
    switch (this.status) {
      case 'Talking':
        this.order = 0
        break
      case 'Broading':
        this.order = 1
        break
      case 'Idle':
        this.order = 2
        break
      case 'OffLine':
        this.order = 3
        break
      case 'UnKnow':
        this.order = 4
        if (this.type == '4') {
          this.isRtsp = true
        }
        break
    }
  }

  setMute(muted) {
    this.muted = muted
    if (this.muted) {
      if (this.meetingIcon) {
        this.meetingIcon = 'conf_mute'
      }
    }else {
      if (this.meetingIcon) {
        this.meetingIcon = 'conf'
      }
    }
  }

  mutedAudio(enableAudio) {
    if (this.rtcPeer) {
      this.rtcPeer.peerConnection.getSenders().forEach(sender => {
        if (sender.track.kind == 'audio') {
          sender.track.enabled = enableAudio
          this.muted = !enableAudio
        }
      })
    }
  }

  setDept(deptId, deptName) {
    this.deptId = deptId
    this.deptName = deptName
    if (!this.deptName && this.type==2) {
      this.deptName = 'UnKnow'
      this.deptI18n = true
      return
    }
    this.deptI18n = this.deptName == 'all_area' || this.deptName == 'only_admin';
  }

  getVideoElement() {
    return document.getElementById(this.videoId)
  }

  getAudioElement() {
    return document.getElementById(this.audioId)
  }

  offerToReceiveVideo(error, offerSdp, wp) {
    if (error) return console.error('sdp offer error',error)
    receive(this.type == '1' || this.type==2 ? this.number : this.name, offerSdp, !this.isShowShare ? "1" : "0")
  }

  onIceCandidate(candidate, wp) {
    iceCandidate(candidate, this.type == '1'|| this.type==2 ? this.number : this.name, !this.isShowShare ? "1" : "0")
  }

  dispose(unReset) {
    if (this.rtcPeer) {
      try {
        // 1. 停止所有音视频轨道
        const stream = this.rtcPeer.getLocalStream() || this.rtcPeer.getRemoteStream();
        if (stream) {
          stream.getTracks().forEach(track => track.stop());
        }

        // 2. 调用 kurento 的销毁方法
        this.rtcPeer.dispose();
      } catch (e) {
        console.error('Error during rtcPeer disposal', e);
      } finally {
        // 3. 彻底删除 rtcPeer 属性，而非仅赋值为 null
        delete this.rtcPeer;
        // 4. 清理创建锁标志
        delete this._buildingPeer;
        this._disposed = true
      }
    }
    if (this._screenStream) {
      this._screenStream.getTracks().forEach(track => {
        track.stop();
        track.onended = null; // 移除事件监听
      });
      delete this._screenStream;
      delete this._screenTrack;
    }
    if (this.speakHark) {
      this.speakHark.stop()
      this.speakHark = null
    }
    if (!unReset) {
      this.muted = false
      this.speaking = false
      this.muteVideo = false
      this.playing = false
    }

  }
}
export default Participant



// WEBPACK FOOTER //
// ./src/view/conference/participant.js